import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  productAccessorGetBestSellerPromotionFromOffer,
  productAccessorIsSellerPromotionWithVoucherCode,
} from '../../../../product'
import { useProductPageContext } from '../../productPageContext'
import { ProductPageVolumePricingBadge } from '../../ProductPageVolumePricingBadge/ProductPageVolumePricingBadge'
import { useShouldRenderVolumePricingLabel } from '../../ProductPageVolumePricingBadge/useShouldRenderVolumePricingBadge'
import { ProductBuyBoxSellerPromotionBadge } from '../ProductBuyBoxSellerPromotionBadge/ProductBuyBoxSellerPromotionBadge'

export const ProductAddToCartGroupInfo: FC = () => {
  const { currentOffer, product } = useProductPageContext()
  const renderVolumeBasedPricingLabel = useShouldRenderVolumePricingLabel()

  const sellerPromotion =
    currentOffer && productAccessorGetBestSellerPromotionFromOffer(currentOffer)
  const shouldRenderSellerPromotionBadge =
    sellerPromotion &&
    !productAccessorIsSellerPromotionWithVoucherCode(sellerPromotion)
  const shouldRenderBadges =
    renderVolumeBasedPricingLabel || shouldRenderSellerPromotionBadge

  return (
    <>
      {sellerPromotion || renderVolumeBasedPricingLabel ? (
        <p className="text-l font-medium">
          <FormattedMessage id="seller.promotion.product.discount.buybox" />
        </p>
      ) : null}

      {shouldRenderBadges ? (
        <div className="flex flex-wrap">
          {renderVolumeBasedPricingLabel ? (
            <ProductPageVolumePricingBadge className="mb-2.5 mr-2.5" />
          ) : null}
          {shouldRenderSellerPromotionBadge ? (
            <ProductBuyBoxSellerPromotionBadge
              offer={currentOffer}
              product={product}
              sellerPromotion={sellerPromotion}
            />
          ) : null}
        </div>
      ) : null}
    </>
  )
}
